import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'
import React from 'react'

const LegendInfo = (props) => {
  return (
    <CModal
      alignment="center"
      scrollable
      visible={props.infoPageModal}
      onClose={() => props.setInfoPageModal(false)}
    >
      <CModalHeader>
        <CModalTitle>Information</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <p>
          <strong>FP</strong>: Fantasy Points
        </p>
        <p>
          <strong>RS</strong>: Runs{' '}
        </p>
        <p>
          <strong>BF</strong>: Balls Faced
        </p>
        <p>
          <strong>4S</strong>: Fours
        </p>
        <p>
          <strong>6S</strong>: Sixes
        </p>
        <p>
          <strong>OVRS</strong>: Overs
        </p>
        <p>
          <strong>MDNS</strong>: Maidens
        </p>
        <p>
          <strong>RG</strong>: Runs Given
        </p>
        <p>
          <strong>WKTS</strong>: Wickets
        </p>
        <p>
          <strong>CS</strong>: Catches
        </p>
        <p>
          <strong>CWK</strong>: Catches (Wicket-Keeper)
        </p>
        <p>
          <strong>ST</strong>: Stumpings
        </p>
        <p>
          <strong>ROD</strong>: Run-Out Direct
        </p>
        <p>
          <strong>ROA</strong>: Run-Out Assisted Points
        </p>
        <p>
          <strong>DK</strong>: Duck
        </p>
        <p>
          <strong>HT</strong>: Hat-Trick
        </p>
        <p>
          <strong>NO</strong>: Not Out
        </p>

        <p>
          <strong>HWOT</strong>: How Out (Batting)
        </p>
        <p>
          <strong>WB</strong>: Wicket Dismissal (Bowled)
        </p>
        <p>
          <strong>WCT</strong>: Wicket Dismissal (Caught)
        </p>
        <p>
          <strong>WCWK</strong>:Wicket Dismissal (Caught WK)
        </p>
        <p>
          <strong>WLBW</strong>: Wicket Dismissal (LBW)
        </p>
        <p>
          <strong>WST</strong>: Wicket Dismissal (Stump)
        </p>
        <p>
          <strong>WHW</strong>: Wicket Dismissal (Hit Wicket)
        </p>
        <p>
          <strong>DOTP</strong>: Dots Played
        </p>
        <p>
          <strong>DOTB</strong>: Dots Bowled
        </p>
      </CModalBody>
      <CModalFooter>
        <CButton color="primary" onClick={() => props.setInfoPageModal(false)}>
          Cancel
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default LegendInfo
